export const CHARS_PER_POINT = 0.26;
